import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

interface Props {
    label: string;
    value: string;
    className?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        fontSize: "14px",
        display: "flex",
        padding: "4px 0"
    },
    label: {
        minWidth: "150px",
        marginRight: "8px"
    },
    value: {
        marginLeft: "8px",
        flex: 1,
        fontWeight: 500,
        whiteSpace: "pre-wrap"
    }
}));

const SettingsLabel: React.FC<Props> = props => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, props.className)}>
            <span className={classes.label}>
                {props.label}:
            </span>
            <span className={classes.value}>
                {props.value}
            </span>
        </div>
    );
};

export default SettingsLabel;
